import React from "react";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";

export function MarkdownRenderer({ content, theme = "dark" }: { content: string; theme?: "dark" | "light" }) {
  if (!content) return null;
  const isDark = theme === "dark";

  return (
    <div className="space-y-3">
      <ReactMarkdown
        remarkPlugins={[remarkBreaks, remarkGfm]}
        components={{
          h1: ({ children }) => (
            <h1 className={`mt-6 text-lg font-bold ${isDark ? "text-white" : "text-slate-900"}`}>{children}</h1>
          ),
          h2: ({ children }) => (
            <h2 className={`mt-5 text-base font-bold ${isDark ? "text-white" : "text-slate-900"}`}>{children}</h2>
          ),
          h3: ({ children }) => (
            <h3 className={`mt-4 text-sm font-bold ${isDark ? "text-white" : "text-slate-900"}`}>{children}</h3>
          ),
          h4: ({ children }) => (
            <h4 className={`mt-4 text-xs font-bold ${isDark ? "text-white" : "text-slate-900"}`}>{children}</h4>
          ),
          p: ({ children }) => <p className={isDark ? "text-white/70" : "text-slate-600"}>{children}</p>,
          strong: ({ children }) => (
            <strong className={`font-bold ${isDark ? "text-white" : "text-slate-900"}`}>{children}</strong>
          ),
          hr: () => <hr className={`my-4 ${isDark ? "border-white/10" : "border-slate-200"}`} />,
          ul: ({ children }) => <ul className={`list-disc pl-4 ${isDark ? "text-white/70" : "text-slate-600"}`}>{children}</ul>,
          ol: ({ children }) => <ol className={`list-decimal pl-4 ${isDark ? "text-white/70" : "text-slate-600"}`}>{children}</ol>,
          li: ({ children }) => <li className="mb-1">{children}</li>,
          br: () => <br />,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
